import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MsalService } from "@azure/msal-angular";
import { Idle } from "@ng-idle/core";
import { Store } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TransferDataDTO } from "src/app/_models/TransferLearner";
import { Userprofile } from "src/app/_models/Userprofile";
import { PublicUserSessionService } from "src/app/_services/public-user-session.service";
import {
  StartTransfer,
  UndoTransfer,
} from "src/app/_store/transfer-learner/transfer-learner.actions";
import {
  selectStartTransferError,
  selectStartTransferResult,
  selectTransferLearnerLoader,
  selectUndoTranferResult,
} from "src/app/_store/transfer-learner/transfer-learner.selectors";
import { AppConstants } from "src/app/constants/constants";
import { FormComponentDeactivateGuard } from "src/app/guards/form-component-deactivate.guard";
import { PopUpReminderComponent } from "src/app/views/learning/learning-plan/dialog/pop-up-reminder/pop-up-reminder.component";

@Component({
  selector: "app-confirm-transfer-dialog",
  templateUrl: "./confirm-transfer-dialog.component.html",
  styleUrls: ["./confirm-transfer-dialog.component.scss"],
})
export class ConfirmTransferDialogComponent implements OnInit, OnDestroy {
  @HostListener(AppConstants.WIN_BEFOREUNLOAD, [AppConstants.EVENT_PROP])
  unloadNotification($event: any): void {
    if (this.deactivateGuard.dirty && !this.allowUnload) {
      $event.returnValue = true;
    }
  }
  allowUnload: boolean = false;
  confirmed = false;
  undo = false;
  currentProfile: Userprofile;
  agreeCheckbox = new FormControl(false);
  loader$: Observable<boolean>;
  destroy$: Subject<void> = new Subject<void>();
  success: boolean | null = null;
  countdown: number = 10;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TransferDataDTO,
    public dialogRef: MatDialogRef<PopUpReminderComponent>,
    private store: Store,
    private idle: Idle,
    private authService: MsalService,
    private deactivateGuard: FormComponentDeactivateGuard,
    private publicUserSessionService: PublicUserSessionService
  ) {}

  ngOnInit(): void {
    this.loader$ = this.store.select(selectTransferLearnerLoader);
    this.initSelectors();
    this.deactivateGuard.dirty = true;
  }

  initSelectors(): void {
    this.selectorUndoTransferResult();
    this.selectorStartTransferResult();
    this.selectorStartTransferError();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  selectorStartTransferResult(): void {
    this.store
      .select(selectStartTransferResult)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: boolean) => {
        if (result) {
          this.success = result;
          if(this.success) {
            this.deactivateGuard.dirty = false;
            this.onProcessLogout();
            this.startCountdown();
          }
        }
      });
  }

  startCountdown(): void {
    const intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  selectorStartTransferError(): void {
    this.store
      .select(selectStartTransferError)
      .pipe(takeUntil(this.destroy$))
      .subscribe((error: HttpErrorResponse) => {
        if (error && error.error) {
          this.deactivateGuard.dirty = false;
          this.success = false;
        }
      });
  }
  selectorUndoTransferResult(): void {
    this.store
      .select(selectUndoTranferResult)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: boolean) => {
        if (result) {
          this.deactivateGuard.dirty = false;
          this.undo = true;
        }
      });
  }

  agree(): void {
    if (!this.agreeCheckbox.value) {
      document
        .getElementById(AppConstants.AGREE_CONTAINER_ID)
        .classList.add(AppConstants.SHAKE_CLASS, AppConstants.INVALID_CLASS);
      setTimeout(() => {
        document
          .getElementById(AppConstants.AGREE_CONTAINER_ID)
          .classList.remove(AppConstants.SHAKE_CLASS);
      }, 500);
    } else {
      this.confirmed = true;
      setTimeout(() => {
        this.store.dispatch(StartTransfer());
      }, 500);
    }
  }

  undoTransfer(): void {
    this.store.dispatch(UndoTransfer({ transferId: this.data.transferId }));
  }

  logOut(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.idle.stop();
    this.idle.clearInterrupts();
    this.authService.logout();
  }

  onProcessLogout(): void {
    this.publicUserSessionService.clearSession$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.logOut();
    });
  }
}
